import ticketDetails from '../localization-messages/ticketDetails/ar-AE.json';
import ticketCancelForm from '../localization-messages/ticketCancelForm/ar-AE.json';
import ticketListing from '../localization-messages/ticketListing/ar-AE.json';
import ticketForm from '../localization-messages/ticketForm/ar-AE.json';
import headerFooter from '../localization-messages/headerFooter/ar-AE.json';
import reconfirmUserDetailsModal from '../localization-messages/reconfirmUserDetailsModal/ar-AE.json';
import termsModal from '../localization-messages/termsModal/ar-AE.json';

export const arAETranslations = {
  ticketDetails,
  ticketCancelForm,
  ticketListing,
  ticketForm,
  headerFooter,
  reconfirmUserDetailsModal,
  termsModal,
};
